import EquipeUsuarioModal from "../../../Components/EquipeUsuarioModal/EquipeUsuarioModal"
import { AddCircle, Create, Search } from "@mui/icons-material"
import { Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { filtroTextoPesquisa } from "../../../Utils/Utils"
import { CadastroUsuario } from "./CadastroUsuario/CadastroUsuario"
import PlagiarismIcon from '@mui/icons-material/Plagiarism'

const UsuariosConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [openEquipe, setOpenEquipe] = useState(false)
    const [idToEdit, setIdToEdit] = useState(null)
    const [user, setUser] = useState("")

    const tableColumns = [
        {
            name: 'Código',
            selector: row => row.id,
            grow: 0.4
        },
        {
            name: 'Nome',
            selector: row => row.nome
        },
        {
            name: 'E-mail',
            selector: row => row.email
        },
        {
            name: 'Telefone',
            selector: row => row.celular
        },
        {
            name: 'Função',
            selector: row => row.funcao
        },
        {
            name: 'Editar',
            cell: (row) =>
                <div>
                    <PlagiarismIcon sx={{ cursor: 'pointer' }} onClick={() => {
                        setOpenEquipe(true)
                        setUser(row)
                    }}/>
                    <Create sx={{ cursor: 'pointer' }} onClick={() => { editUsuario(row.id) }}/>
                </div>,
            button: true
        }
        // {
        //     name: 'Excluir',
        //     cell: (row) => <Delete sx={{ cursor: 'pointer', color: 'red' }} onClick={() => { setDeleteIdTag(row.id); setConfirmDelete(true) }}/>,
        //     ignoreRowClick: true,
        //     button: true
        // }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [usuariosList, setUsuariosList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(usuariosList, filterText, ['id', 'nome', 'email', 'funcao', 'equipe'])

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setUsuariosList(msg.data.usuarios)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodosUsuariosConfig", getWsResponse)
        sendWs("buscarTodosUsuariosConfig", { descartaUserOne: true })
    }, [])

    const editUsuario = (id) => {
        setIdToEdit(id)
        setOpenCadastro(true)
    }

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro &&
            <CadastroUsuario
                openCadastro={openCadastro}
                setOpenCadastro={setOpenCadastro}
                idToEdit={idToEdit}
                setIdToEdit={setIdToEdit}
            />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        onSubmit={handleSearch}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                     Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="button_teste"
                            color="one_primary"
                            variant="contained"
                            onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                            sx={{ width: '148px', height: '30px' }}
                        >
                            <AddCircle sx={{ marginRight: '7px' }} />
                            Novo
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container xs={12} sx={{
                // padding: '5px',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
                // overflowY: 'scroll',
                // "::-webkit-scrollbar": {
                //     width: "6px",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-track": {
                //     background: "#D9D9D9",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb": {
                //     background: "#888",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb:hover": {
                //     background: "#555",
                //     borderRadius: '5px'
                // }
            }}>
                {usuariosList &&
                <OneTable
                    columns={tableColumns}
                    data={filteredDataList}
                    progressPending={!loading}
                    dobleClickCallback={editUsuario}
                    // pagination
                    // paginationPerPage={rowsPage}
                    // paginationRowsPerPageOptions={[rowsPage, 5, 10, 15, 20, 25, 30]}
                    // paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                />
                }
            </Grid>
            <Grid>
                { openEquipe &&
                    <EquipeUsuarioModal
                        open={openEquipe}
                        setOpen={setOpenEquipe}
                        loading={!loading}
                        dado={user}
                    />
                }
            </Grid>
        </Grid>
    )
}

export default UsuariosConfig
